// extracted by mini-css-extract-plugin
export default {"popWrapper":"subCategory_popWrapper__2hG9R","popItem":"subCategory_popItem__qngZ0","activePop":"subCategory_activePop__FsjHa","activeIcon":"subCategory_activeIcon__vwoeP"};